<template>
  <div>
    <DesktopCorporateTraining v-if="!isMobile" />
    <MobileCorporateTraining v-if="isMobile" />
  </div>
</template>

<script>
import DesktopCorporateTraining from "@/components/corporate/training/desktop/CorporateTraining";
import MobileCorporateTraining from "@/components/corporate/training/mobile/CorporateTraining";
export default {
  components: {
    DesktopCorporateTraining,
    MobileCorporateTraining,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  metaInfo() {
      return {
        title: this.$route.meta.title,
        meta: [
          { name: "description", content: this.$route.meta.description},
          {
            vmid: 'robots',
            name: 'robots',
            content: 'index, follow'
          }
        ],
      };
    },
  methods: {
    handleView() {
      this.isMobile = window.innerWidth <= 990;
    },
  },
  mounted() {
    this.$gtag.pageview(this.$route);
    this.$utils.scrollTop()
  },
  beforeMount() {
    this.handleView();
  }
};
</script>
